export const get = (key) => localStorage.getItem(key);
export const set = (key, value) => localStorage.setItem(key, value);
export const remove = (key) => localStorage.removeItem(key);

const AUTH_KEYS = ['isLogin', 'token', 'refreshToken', 'userInfo', 'permissions'];

export const clearAuth = () => {
  AUTH_KEYS.forEach(key => localStorage.removeItem(key));
};

export const getUserInfo = () => {
  const raw = localStorage.getItem('userInfo');
  if (!raw) return {};
  try {
    return JSON.parse(raw);
  } catch {
    return {};
  }
};

export const clearAuthIfNewSession = () => {
  const navEntry = performance.getEntriesByType('navigation')[0];
  const isRefresh = navEntry && navEntry.type === 'reload';
  const isBackForward = navEntry && navEntry.type === 'back_forward';

  if (isRefresh || isBackForward) return;

  const hasValidReferrer = !!document.referrer &&
    new URL(document.referrer).origin === window.location.origin;

  if (!hasValidReferrer) {
    clearAuth();
  }
};